import { render } from "./EditProductInfo.vue?vue&type=template&id=701104e0&scoped=true"
import script from "./EditProductInfo.vue?vue&type=script&lang=js"
export * from "./EditProductInfo.vue?vue&type=script&lang=js"

import "./EditProductInfo.vue?vue&type=style&index=0&id=701104e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701104e0"]])

export default __exports__